import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getTemplates} from './getTemplates';

export const templatesQueryOptions = () =>
  queryOptions({
    queryKey: keys.templates.list(),
    queryFn: getTemplates,
    /* Статусы шаблонов синхронизируются с Meta фоново, раз в несколько
       минут. Дёргать список на каждый фокус окна смысла нет. */
    staleTime: 5 * 60_000,
  });
